import { Check, Copy } from 'lucide-react';

import {
    type LearnTask,
    promptPlainText,
    type SlottedPrompt,
} from '@apps/web/features/learn_phoebe/model/learn_content';
import { useCopyPrompt } from '@apps/web/features/learn_phoebe/model/use_copy_prompt';
import { type LearnPhoebeSurface } from '@apps/web/features/learn_phoebe/model/use_learn_phoebe_analytics';
import { cn } from '@apps/web/lib/utils';

// The copy action that sits beside "Try in chat": same prompt, taken by hand
// instead of run. Copies the plain template with the bracketed slots intact,
// so pasting into the chat still reads naturally.
export function CopyPromptAction({
    prompt,
    surface,
    taskId,
    stepId,
    className,
}: {
    readonly prompt: SlottedPrompt;
    readonly surface: LearnPhoebeSurface;
    readonly taskId: LearnTask['id'];
    readonly stepId: string | null;
    readonly className?: string;
}) {
    const { isCopied, copyPrompt } = useCopyPrompt({ surface, taskId, stepId });
    const text = promptPlainText(prompt);

    return (
        <button
            type="button"
            onClick={() => {
                copyPrompt(text);
            }}
            className={cn(
                'text-muted-foreground hover:text-foreground flex cursor-pointer items-center gap-1.5 text-sm transition-colors',
                className,
            )}
        >
            {isCopied ? (
                <Check aria-hidden="true" className="size-4 text-green-600" />
            ) : (
                <Copy aria-hidden="true" className="size-4" />
            )}
            {isCopied ? 'Copied' : 'Copy prompt'}
        </button>
    );
}
